var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useEffect } from 'react';
export const useOnFocusout = ({ callback, element, }) => {
    _react_refresh_temp_1();
    const onFocusoutHandler = useCallback((event) => {
        if (element.current &&
            event.relatedTarget &&
            !element.current.contains(event.relatedTarget)) {
            callback();
        }
    }, [callback, element]);
    useEffect(() => {
        const currentElement = element.current;
        if (currentElement) {
            currentElement.addEventListener('focusout', onFocusoutHandler);
        }
        return () => currentElement?.removeEventListener('focusout', onFocusoutHandler);
    }, [element, onFocusoutHandler]);
};
_react_refresh_temp_1(useOnFocusout, "uH1YbrEZbBWQG73bSGalqSgmBAk=");
